import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { mapLightTheme } from './LightTheme';

const colors: Colors = {
  primary: {
    lighten: '#00877F',
    default: '#00544F',
    dim: 'rgba(0,84,79,0.4)',
    mute: 'rgba(0,84,79,0.1)',
  },
  gray: {
    '100': '#1C1D28',
    '000': '#D5DEE0',
    '010': '#E1EAEB',
    main: '#EDF7F7',
    '020': '#E8F2F2',
    '030': '#DAE3E4',
    '040': '#CCD5D6',
    '050': '#C3CBCD',
    '060': '#B9C1C4',
    '070': '#AEB5B8',
    '080': '#90969B',
    '090': '#61656D',
  },
  green: {
    lighten: '#3CA371',
    default: '#2E7E57',
    dim: 'rgba(46,126,87,0.4)',
    mute: 'rgba(46,126,87,0.1)',
  },
  red: {
    lighten: '#C74454',
    default: '#A63240',
    dim: 'rgba(166,50,64,0.4)',
    mute: 'rgba(166,50,64,0.1)',
  },
  yellow: {
    lighten: '#E3A71C',
    default: '#B68616',
    dim: 'rgba(182,134,22,0.4)',
    mute: 'rgba(182,134,22,0.1)',
  },
  orange: {
    lighten: '#FF6511',
    default: '#DD4E00',
    dim: 'rgba(221,78,0,0.4)',
    mute: 'rgba(221,78,0,0.1)',
  },
  blue: {
    lighten: '#5FA2E7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9F73D7',
    default: '#844BCC',
  },
  white: {
    default: '#FFFFFF',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const LightAurosTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightAuros',

  colorTextDefaultButton: colors.black.default,
  colorTextDefaultButtonHover: colors.black.default,
  colorTextDefaultButtonFocus: colors.black.default,
  colorTextDefaultButtonActive: colors.black.default,
  colorTextDefaultButtonDisabled: setAlpha(0.5, colors.black.default),

  colorTextWarningButton: colors.black.default,
  colorTextWarningButtonHover: colors.black.default,
  colorTextWarningButtonFocus: colors.black.default,
  colorTextWarningButtonActive: colors.black.default,
  colorTextWarningButtonDisabled: setAlpha(0.5, colors.black.default),

  colorTextMutedButton: colors.black.default,
  colorTextMutedButtonHover: colors.black.default,
  colorTextMutedButtonFocus: colors.black.default,
  colorTextMutedButtonActive: colors.black.default,
  colorTextMutedButtonDisabled: setAlpha(0.5, colors.black.default),
});
